
//common jquery variables
var $tabCarousel,
    $carouselTabs,
    $carouselBelt,

    //boolean variable that determines if the tabs have been converted to a carousel
    carouselActivated,


    carouselBeltViewport,
    carouselBeltOffset,
    totalTabOffset,

    //functions related to carousel
    setupCarousel,
    carouselLogic,
    resetCarouselStyles,
    carouselGoToSlide,
    windowResizeHandler,
    alphaCarouselInit;



jQuery.fn.InitializeTabs = function (options) {

    var pageTabBaseUrl = options.pageTabBaseUrl;
    var innerPageTabBaseUrl = options.innerPageTabBaseUrl;

    function bindInnerTabClicks() {
        $('.js-custom-tab').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $thisEl = $(this);

            var url = $thisEl.attr("href");
            var bioid = $thisEl.data('bioid');

            var $pageTitleEl = $thisEl.siblings('.js-tabpagetitle');
            var pageTitle = $pageTitleEl.length > 0 ? $pageTitleEl.val() : "";

            History.pushState({ 'bioid': bioid, 'pagetitle': pageTitle }, '', url);

            return false;
        });
    }

    function bindMainNavClicks() {
        $('.js-tabs-nav-link').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $thisEl = $(this);

            var url = $thisEl.attr("href");
            var tabid = $thisEl.data('tabid');
            var $pageTitleEl = $thisEl.siblings('.js-tabpagetitle');
            var pageTitle = $pageTitleEl.length > 0 ? $pageTitleEl.val() : "";

            History.pushState({ 'tabid': tabid, 'pagetitle': pageTitle }, '', url);
            carouselGoToSlide($thisEl);
            return false;
        });

        $('.layout-main').on('click', '.js-tab-trigger-prev', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var tabs = $('.js-tabs-nav-link');
            var activeTab = $('.is-active-tab');
            var currentPosition = tabs.index(activeTab);

            if (currentPosition == 0) {
                var lastTab = tabs.last();
                lastTab[0].click();
            } else {
                var prevTab = tabs.eq(currentPosition - 1);
                prevTab[0].click();// .trigger('click');
            }
            scrolltotop();
            return false;
        });
        $('.layout-main').on('click', '.js-tab-trigger-next', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var tabs = $('.js-tabs-nav-link');
            var activeTab = $('.is-active-tab');
            var currentPosition = tabs.index(activeTab);

            if (currentPosition == tabs.length - 1) {
                var firstTab = tabs.first();
                firstTab[0].click();
            } else {
                var nextTab = tabs.eq(currentPosition + 1);
                nextTab[0].click();// .trigger('click');
            }
            scrolltotop();
            return false;
        });
    }

    function scrolltotop() {
        $("html, body").animate({
            scrollTop: $(".tabs-nav").offset().top - 100
        }, "slow");
    }

    function addTabResponseToBody(html) {
        $('.js-tabs').html(html);
        bindInnerTabClicks();

        var $accordionsNode = $('.accordion-module');
        var $overviewExpandNode = $('.js-overview-expand');

        if ($accordionsNode.length) {
            $accordionsNode.InitializeAccordions();
        }

        if ($overviewExpandNode.length) {
            $overviewExpandNode.InitializeExpandNodes();
        }
    }

    function addBioResponseToBody(html) {
        $('.js-custom-tabs-rte').html(html);
        var $accordionsNode = $('.accordion-module');

        if ($accordionsNode.length) {
            $accordionsNode.InitializeAccordions();
        }
    }

    //Main nav tabs
    bindMainNavClicks();

    //Inner tab tabs
    bindInnerTabClicks();

    window.onstatechange = function () {

        var currentState = History.getState();

        var tabid = !!currentState.data ? currentState.data.tabid : "";
        var bioid = !!currentState.data ? currentState.data.bioid : "";
        var pageTitle = !!currentState.data ? currentState.data.pagetitle : "";

        var url = currentState.url;
        var guid = $('#entityguid').val();

        //Check to see if bioid value exists otherwise use tabid on request
        if (!!bioid) {

            //Remove active class from all innerTabs
            $('.js-custom-tab').removeClass('is-active-custom');
            var successFunction = addBioResponseToBody;
            var $currentBio = $("a[data-bioid='" + bioid + "']");

            if ($currentBio.length === 0) {
                $currentBio = $('.js-tabs-nav-link').first();
            }

            $currentBio.addClass('is-active-custom');

            var tabParam = getQueryString('bio', url);
            var bioTabName = !!tabParam ? tabParam : "";
            var queryString = bioTabName == "" ? "?guid=" + guid : "?bio=" + encodeURIComponent(bioTabName) + '&guid=' + guid;
            var requestURI = innerPageTabBaseUrl + queryString;

            carouselBeltViewport = $carouselBelt.width();
            carouselBeltOffset = $carouselBelt.offset().left;
            totalTabOffset = $currentBio.offset().left + $currentBio.width();

            console.log(carouselBeltOffset, totalTabOffset, carouselBeltViewport);

        } else {
            //Remove active class from all tabs
            $('.js-tabs-nav-link').removeClass('is-active-tab');
            var successFunction = addTabResponseToBody;
            var $currentTab = $("a[data-tabid='" + tabid + "']");

            if ($currentTab.length === 0) {
                $currentTab = $('.js-tabs-nav-link').first();
            }

            //Make this the active tab
            $currentTab.addClass('is-active-tab');

            var tabParam = getQueryString('tab', url);
            var tabName = !!tabParam ? tabParam : "";
            var queryString = tabName == "" ? "?guid=" + guid : "?tab=" + encodeURIComponent(tabName) + '&guid=' + guid;
            var requestURI = pageTabBaseUrl + queryString;

            carouselBeltViewport = $carouselBelt.width();
            carouselBeltOffset = $carouselBelt.offset().left;
            totalTabOffset = $currentTab.offset().left + $currentTab.width();

            console.log(carouselBeltOffset, totalTabOffset, carouselBeltViewport);
        }

        if (!!pageTitle) {
            $(document).prop('title', pageTitle);
        }

        $.ajax({
            url: requestURI,
            success: successFunction,
            dataType: 'html'
        });
    };
};



$(function () {
    $tabCarousel = $('.js-tab-carousel');

    if ($tabCarousel.length === 0) {
        return;
    }

    $carouselTabs = $tabCarousel.find('.js-tabs-nav-list');
    $carouselBelt = $tabCarousel.find('.js-tabs-belt');

    var windowWidth = window.innerWidth,
        mobileState = false,
        carouselActivated = false,
        $carouselTabItems = $tabCarousel.find('.tabs-nav__item'),
        $carouselArrowLeft = $tabCarousel.find('.js-arrow-left'),
        $carouselArrowRight = $tabCarousel.find('.js-arrow-right'),
        $carouselCurrentTab = $carouselTabItems.find('.is-active-tab'),
        carouselViewport;


    setupCarousel = function () {
        carouselViewport = $carouselBelt.width();
        var totalWidthOfElementsInPx = 0;

        $carouselTabItems.each(function () {
            totalWidthOfElementsInPx += $(this).width(); //offset threshold in case Museo hasnt been loaded
        });

        //setup width
        $carouselTabs.css('width', totalWidthOfElementsInPx + 'px');

        if (totalWidthOfElementsInPx > (carouselViewport + 80)) {
            $carouselArrowLeft.css('display', 'block');
            $carouselArrowRight.css('display', 'block');

            var $lastTab = $($carouselTabItems[$carouselTabItems.length - 1]);
            var lastTabRightPosition = Math.round($lastTab.offset().left + $lastTab.width());
            var viewportRightPosition = Math.round($carouselBelt.offset().left + $carouselBelt.width());

            if (lastTabRightPosition < viewportRightPosition) {
                var marginLeft = $carouselTabs.css('margin-left');
                var currentMargin = !!marginLeft ? parseInt($carouselTabs.css('margin-left')) : 0;

                $carouselTabs.css('margin-left', (currentMargin + (viewportRightPosition - lastTabRightPosition)) + 'px');
            }

            carouselActivated = true;

        } else {
            $carouselArrowLeft.css('display', 'none');
            $carouselArrowRight.css('display', 'none');
            $carouselTabs.css('margin-left', '');
            carouselActivated = false;
        }

    };

    resetCarouselStyles = function () {

        $carouselTabs.css({
            'width': 'auto'
        });
    };


    carouselLogic = function (direction) {
        var marginLeft = $carouselTabs.css('margin-left');
        var currentMargin = !!marginLeft ? parseInt($carouselTabs.css('margin-left')) : 0;
        //if the page is big enough the tabs don't start at offset 0
        var carouselSideMargin = $('.js-tab-carousel').offset().left;
        if (carouselSideMargin < 0) carouselSideMargin = 0;

        if (direction === 'next') {
            //Find right most element that is fully shown on screen

            $carouselTabItems.each(function (index) {
                var thisElement = $(this);
                var rightPosition = Math.round(thisElement.offset().left + thisElement.width());
                var viewportRightPosition = Math.round($carouselBelt.offset().left + $carouselBelt.width());

                if (rightPosition > viewportRightPosition) {
                    $carouselTabs.css('margin-left', (currentMargin - (rightPosition - viewportRightPosition)) + 'px');
                    //break
                    return false;
                }
            });
        } else {
            $carouselTabItems.each(function (index) {
                var thisElement = $($carouselTabItems[$carouselTabItems.length - index - 1]);
                var leftPosition = Math.round(thisElement.offset().left);
                var viewportLeftPosition = Math.round($carouselBelt.offset().left);

                if (leftPosition < viewportLeftPosition) {
                    $carouselTabs.css('margin-left', (currentMargin + (viewportLeftPosition - leftPosition)) + 'px');
                    //var elementWidth = $(this).width();
                    //$carouselTabs.css('margin-left', '0px');
                    //break
                    return false;
                }
            });
        }
    };

    windowResizeHandler = function () {
        var resizeTimer;

        $(window).on('resize.carouselTabs', function () {

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
                windowWidth = window.innerWidth;

                mobileState = true;
                setupCarousel();
            }, 500);
        });
    };

    carouselGoToSlide = function ($currentTab) {
        var tabOffset = $currentTab.length ? $currentTab.offset().left : '',
            tabWidth = $currentTab.outerWidth() * 0.93,
            totalTabOffset = tabWidth + tabOffset,

            carouselBeltViewport = $carouselBelt.width(),
            carouselBeltOffset = $carouselBelt.offset().left,

            tabDifference,

            marginLeft = $carouselTabs.css('margin-left'),
            currentMargin = !!marginLeft ? parseInt($carouselTabs.css('margin-left')) : 0,

            totalCarouselViewport = carouselBeltViewport + carouselBeltOffset;


        totalCarouselViewport = parseInt(totalCarouselViewport, 10);
        var absoluteLeftCutoff = $('.js-tabs-belt') ? $('.js-tabs-belt').position().left : '';
        var currentTabLeftPosition = $currentTab.length ? $currentTab.position().left : '';

        //if current tab appears outside of viewport, adjust position of belot
        if (totalTabOffset > totalCarouselViewport) {
            if (currentMargin < 0) {
                totalTabOffset -= currentMargin;
            }
            tabDifference = totalCarouselViewport - totalTabOffset - 5;

            $carouselTabs.css('margin-left', (tabDifference) + 'px');
        }

        //slide left-chopped tabs to the right
        else if (currentTabLeftPosition < absoluteLeftCutoff) {
            $carouselTabs.css('margin-left', (currentMargin - (currentTabLeftPosition - 30)) + 'px');
        }
    };


    function alphaCarouselInit() {


        //Setup variables
        setupCarousel();

        //bind Events
        $carouselArrowLeft.on('click', function (ev) {
            ev.preventDefault();
            carouselLogic('prev');
        });

        $carouselArrowRight.on('click', function (ev) {
            ev.preventDefault();
            carouselLogic('next');
        });

        //setup windowsize event handler
        windowResizeHandler();


    }

    alphaCarouselInit();


    if (carouselActivated) {

        carouselGoToSlide($carouselCurrentTab);
    }

});
